import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BusinessProcessListComponent } from './business-process/business-process-list.component';
import { BusinessProcessStartListComponent } from './instance/businessProcessStartList.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { TooltipModule} from 'ngx-bootstrap/tooltip';
import { TabsModule } from 'ngx-bootstrap/tabs';

import { ConsolidationModalComponent } from './business-process/consolidation-modal/consolidation-modal.component';
import { HistoryReportVisibilityComponent } from './business-process/history-report-visibility/history-report-visibility.component';
import { routing } from './business-process/business-process.routing';
import { RelatedBusinessProcessConfigurationComponent } from './business-process/related-business-process-configuration/related-business-process-configuration.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ManageLockedElementsComponent } from './business-process/manage-locked-elements/manage-locked-elements.component';
import { RecoverVersionComponent } from './business-process/recover-version/recover-version.component';
import { RecoverVersionChangeLogComponent } from './business-process/recover-version/recover-version-change-log.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonComponentsModule } from '../../common/common.module';
import { BusinessProcessDetailComponent } from './business-process/business-process-detail/business-process-detail.component';
import { ImportComponent } from './business-process/import/import.component';
import { StateDetailComponent } from './business-process/state-detail/state-detail.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { GenericInputModalComponent } from '../../generic-modal/generic-input-modal/generic-input-modal.component';
import { FieldDetailComponent } from './business-process/field-detail/field-detail.component';
import { FieldsManagementComponent } from './business-process/fields-management/fields-management.component';
import { LibraryItemDetailsComponent } from './business-process/business-process-detail/library-item-details/library-item-details.component';
import { FieldsMultipleEditionComponent } from './business-process/fields-management/fields-multiple-edition/fields-multiple-edition.component';
import { GraphDetailComponent } from './business-process/business-process-detail/graph-detail/graph-detail.component';
import { BusinessProcessInstanceHistoryComponent } from './reports/business-process-instance-history/business-process-instance-history.component';
import { BusinessProcessInstanceOverrideComponent } from './administration/business-process-instance-override/business-process-instance-override.component';
import { DropdownMultiselectComponent } from '../../common/dropdown-multiselect/dropdown-multiselect.component';
import { ReportsFilterComponent } from '../../common/reports-filter/reports-filter.component';
import { InstanceHistoryStateLifeCycleComponent } from './reports/instance-history-stateLifeCycle/instance-history-stateLifeCycle.component';
import { TabIntanceOverrideComponent } from './administration/business-process-instance-override/tab-intance-override/tab-intance-override.component';
import { ScheduleModalComponent } from './administration/business-process-instance-override/schedule-modal/schedule-modal.component';
import { InstanceHistoryDetailsComponent} from './reports/business-process-instance-history/instance-history-details/instance-history-details.component';
import {reportsRouting} from './reports/reports.routing';
import { HistoryTimelineComponent } from './reports/business-process-instance-history/instance-history-details/history-timeline/history-timeline.component';
import {FieldValueDetailComponent} from './reports/business-process-instance-history/instance-history-details/field-value-details/field-value-detail.component';
import { GenericSelectModalComponent } from '../../generic-modal/generic-select-modal/generic-select-modal.component';
import { ViewInstanceReportComponent } from './reports/business-process-instance-history/view-instance-report/view-instance-report.component';
import { InstanceHistoryResultModalComponent } from './reports/instance-history-stateLifeCycle/instance-history-result-modal/instance-history-result-modal.component';
import { FileSizePipe } from '../../services/pipes/file-size.pipe';
import { TimingAnalysisReportComponent } from './reports/timing-analysis-report/timing-analysis-report.component';
import { InstanceOverrideReportComponent } from './reports/instance-override-report/instance-override-report.component';
import { ResultTemplateComponent } from './reports/timing-analysis-report/result-template/result-template.component';
import { BusinessProcessQueueManagerComponent } from './administration/business-process-queue-manager/business-process-queue-manager.component';
import { QueueManagerFilterComponent } from './administration/business-process-queue-manager/queue-manager-filter/queue-manager-filter.component';
import { QueueActionModalComponent } from './administration/business-process-queue-manager/queue-action-modal/queue-action-modal.component';
import { QueueShiftModalComponent } from './administration/business-process-queue-manager/queue-shift-modal/queue-shift-modal.component';
import {NgxFilesizeModule} from 'ngx-filesize';


@NgModule({
  declarations: [
    BusinessProcessListComponent,
    BusinessProcessStartListComponent,
    ConsolidationModalComponent,
    HistoryReportVisibilityComponent,
    RelatedBusinessProcessConfigurationComponent,
    ManageLockedElementsComponent,
    RecoverVersionComponent,
    RecoverVersionChangeLogComponent,
    BusinessProcessDetailComponent,
    ImportComponent,
    StateDetailComponent,
    GenericInputModalComponent,
    GenericSelectModalComponent,
    FieldDetailComponent,
    FieldsManagementComponent,
    LibraryItemDetailsComponent,
    FieldsMultipleEditionComponent,
    GraphDetailComponent,
    BusinessProcessInstanceHistoryComponent,
    BusinessProcessInstanceOverrideComponent,
    InstanceHistoryStateLifeCycleComponent,
    TabIntanceOverrideComponent,
    InstanceHistoryDetailsComponent,
    ScheduleModalComponent,
    HistoryTimelineComponent,
    FieldValueDetailComponent,
    ViewInstanceReportComponent,
    InstanceHistoryResultModalComponent,
    TimingAnalysisReportComponent,
    InstanceOverrideReportComponent,
    ResultTemplateComponent,
    BusinessProcessQueueManagerComponent,
    QueueManagerFilterComponent,
    QueueActionModalComponent,
    QueueShiftModalComponent
  ],
  entryComponents: [
    BusinessProcessListComponent,
    BusinessProcessStartListComponent,
    ConsolidationModalComponent,
    RecoverVersionChangeLogComponent,
    ImportComponent,
    StateDetailComponent,
    GenericInputModalComponent,
    GenericSelectModalComponent,
    FieldDetailComponent,
    FieldsManagementComponent,
    LibraryItemDetailsComponent,
    FieldsMultipleEditionComponent,
    GraphDetailComponent,
    BusinessProcessInstanceHistoryComponent,
    BusinessProcessInstanceOverrideComponent,
    DropdownMultiselectComponent,
    ReportsFilterComponent,
    InstanceHistoryStateLifeCycleComponent,
    TabIntanceOverrideComponent,
    InstanceHistoryDetailsComponent,
    ScheduleModalComponent,
    HistoryTimelineComponent,
    FieldValueDetailComponent,
    InstanceHistoryResultModalComponent,
    TimingAnalysisReportComponent,
    InstanceOverrideReportComponent,
    BusinessProcessQueueManagerComponent,
    QueueActionModalComponent,
    QueueShiftModalComponent
  ],
  imports: [
    CommonComponentsModule,
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    routing,
    reportsRouting,
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    TabsModule.forRoot(),
    ColorPickerModule,
    NgxFilesizeModule
  ],
  exports: [
    // FileSizePipe
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})

export class RuntimeModule { }
